module.exports = __webpack_public_path__ + "static/media/try-andie-arrow-pt.70a0385f.svg";